import dayjs from 'src/utils/dayjs'
import useSWR from 'swr'
import { baseClient } from '../client'

interface EventsStatusResponse {
  currentUtcTime: string
}

export function useServerTime() {
  return useSWR<string>(
    'server-time',
    async () => {
      const start = performance.now()
      const { data } =
        await baseClient.get<EventsStatusResponse>('/v1/events/status')
      // Calculate the latency caused by the network round trip.
      // Here we assume the latency is symmetric, so dividing by 2 gives the one-way latency.
      // This is sure not accurate, but is enough for general cases like promotional events.
      const latency = (performance.now() - start) / 2
      return dayjs(data.currentUtcTime).add(latency, 'ms').toISOString()
    },
    {
      refreshInterval: 60000,
      revalidateOnFocus: false,
    },
  )
}
